export { default as routes } from './routes';

export const REQUEST_SIZE = 10;

export const RESULTS_LIMIT = 200;

export const USED_CHANNELS_CP = [1, 2, 8, 13];

export const USED_CHANNELS_GLI = [0];

export const COMPANY = {
	CP: 1,
	GLI: 8,
};

export const COMPANY_STR = {
	CP: 'CP',
	GLI: 'GLI',
};

export const DOMAIN = {
	CP: 'cpas.cz',
	GLI: 'generali.cz',
};

export const SORT_TYPE = {
	ASC: 'ASC',
	DESC: 'DESC',
};

export const LINK_TYPE = {
	EXTERNAL: 'EXTERNAL',
	LOCAL: 'LOCAL',
};

export const USER_ROLES = {
	CENTRAL: 'CENTRAL',
	DISTRICT_MANAGER: 'DISTRICT_MANAGER',
	GUARANTOR: 'GUARANTOR',
	REGION_MANAGER: 'REGION_MANAGER',
	AGENCY_MANAGER: 'AGENCY_MANAGER',
	GROUP_MANAGER: 'GROUP_MANAGER',
	SELLER: 'SELLER',
	PPZ: 'PPZ',
};

export const AUTO_FILL_RULES = {
	CENTRAL: ['CENTRAL'],
	REGION_MANAGER: ['CENTRAL', 'GUARANTOR', 'REGION_MANAGER'],
	AGENCY_MANAGER: ['CENTRAL', 'DISTRICT_MANAGER', 'GUARANTOR', 'REGION_MANAGER', 'AGENCY_MANAGER'],
	SELLER: ['CENTRAL', 'DISTRICT_MANAGER', 'GUARANTOR', 'REGION_MANAGER', 'AGENCY_MANAGER', 'GROUP_MANAGER'],
	PPZ: ['CENTRAL', 'DISTRICT_MANAGER', 'GUARANTOR', 'REGION_MANAGER', 'AGENCY_MANAGER', 'GROUP_MANAGER', 'SELLER'],
};

// todo - remove the original one after refactor, rename the new dateformat
export const defaultDateFormat = 'DD/MM/YYYY';
export const defaultDateFormatDateFns = 'dd/MM/yyyy';

export const acceptedDateFormats = [
	'DD/MM/YYYY',
	'D/MM/YYYY',
	'DD/M/YYYY',
	'D/M/YYYY',
	'DD/MM/YY',
	'D/MM/YY',
	'DD/M/YY',
	'D/M/YY',
	'DD.MM.YYYY',
	'D.MM.YYYY',
	'DD.M.YYYY',
	'D.M.YYYY',
	'DD.MM.YY',
	'D.MM.YY',
	'DD.M.YY',
	'D.M.YY',
	'DDMMYY',
	'DDMMYYYY',
	'DDMM',
];

export const monthsArray = [
	'leden',
	'únor',
	'březen',
	'duben',
	'květen',
	'červen',
	'červenec',
	'srpen',
	'září',
	'říjen',
	'listopad',
	'prosinec',
];

export const acceptedDayMonthFormat = ['DD/MM/YYYY', 'DD.MM.YYYY'];

export const appendMode = {
	SET: 'SET',
	APPEND: 'APPEND',
};

export const dragItems = {
	ADDITIONAL_DATA: 'ADDITIONAL_DATA',
	CAMPAIGN_DATA_COLUMN: 'CAMPAIGN_DATA_COLUMN',
	CAMPAIGN_STATE: 'CAMPAIGN_STATE',
};

export const EMPTY_VALUES = {
	OBJECT: {},
	STRING: '',
	ARRAY: [],
};
